module.exports = __webpack_public_path__ + "static/media/icons.139e74e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/icons.svg
// module id = 430
// module chunks = 0